import React from 'react';
import { Redirect } from 'react-router';
import { HomePaths } from '@/services/dictionaries/Paths';
import { useCampaignReportRedirectFromBackend } from './useCampaignReportRedirectFromBackend';

export const RedirectRoutes = () => {
    const campaignUrlMatch = useCampaignReportRedirectFromBackend();

    //is not returning as we need additional actions taken inside the hook.
    if (campaignUrlMatch) return null;

    return <Redirect to={HomePaths.NotFound} />;
};
